/*
 * @Descripttion:
 * @version:
 * @Author: linxi
 * @email: 2194421430@qq.com
 * @Date: 2021-04-14 09:57:36
 * @LastEditors: linxi
 * @LastEditTime: 2023-02-22 17:11:05
 */
import React from 'react'
import { EditableColumnType } from '../../compnents/list/EditableList'
import styles from './stockfloorModal.module.css'
import { Checks } from '../../models/setting'
import { useSelector } from 'react-redux'
import { selectSettings } from '../user/setting/settingSlice'

// 批量设置库存下限
export const Columns = (
  onclick: (text: string, t: any) => void,
  startIndex: number
): EditableColumnType<any>[] => {
  const settings = useSelector(selectSettings)

  // 新老目录展示方式 (老目录没有区分药品类别/无型号)
  const getProcuctInfo = (item: any) => {
    const materialsCategory = item.materialsCategory
    const packSpec = item.packSpec ? item.packSpec : '暂无'
    const spec = item.spec ? item.spec : '-'
    const doseCategory = item.doseCategory ? item.doseCategory : '-'
    const tenantSupplierName = item.tenantSupplierName ? item.tenantSupplierName : '-'
    const model = item.model ? '/' + item.model : ''

    if (settings?.[Checks.MLKG] == 1) {
      if (materialsCategory == '0') {
        // 生产厂家 + 包装规格 + 剂型 
        return tenantSupplierName + '/' + packSpec + '/' + doseCategory
      } else if (materialsCategory == '1' || materialsCategory == '2') {
        // 生产厂家 + 包装规格 + 型号 
        return tenantSupplierName + '/' + packSpec + model
      } else {
        // 生产厂家 + 包装规格 
        return tenantSupplierName + '/' + packSpec
      }
    } else {
      if (materialsCategory == '0') {
        // 生产厂家 + 包装规格 + 剂型 
        return tenantSupplierName + '/' + packSpec + '/' + doseCategory
      } else if (materialsCategory == '1' || materialsCategory == '2') {
        // 生产厂家 + 规格 + 型号 
        return tenantSupplierName + '/' + spec + model
      } else {
        // 生产厂家 + 规格 
        return tenantSupplierName + '/' + spec
      }
    }
  }
  return [
    {
      title: '序号',
      align: 'center',
      width: '10%',
      render: (_1, _2, index) => `${startIndex + index + 1}`,
    },
    {
      title: '物资信息',
      align: 'left',
      dataIndex: 'name',
      sorter: (a, b) => a.name.localeCompare(b.name),
      render: function Element(_, record) {
        return (
          <div style={{ height: '52px' }}>
            <p
              className={styles.nameText}
            >
              {record.name}
            </p>
            <p
              className={styles.productText}
            >
              {getProcuctInfo(record)}
            </p>
          </div>
        )
      },
    },
    {
      title: '库存下限值',
      align: 'center',
      width: '14rem',
      dataIndex: 'inventoryAlert',
      ellipsis: true,
      editable: true,
      onSave: (prev, next) => {
        onclick('submit', { prev, next })
      },
    },
  ]
}
